import React, { useState, useEffect, useCallback } from 'react';
import * as api from '../api';

function LeaderboardPanel() {
  const [rankings, setRankings] = useState([]);
  const [myRanking, setMyRanking] = useState(null);
  const [metric, setMetric] = useState('total_wealth');
  const [total, setTotal] = useState(0);

  const load = useCallback(async () => {
    try {
      const [rRes, mRes] = await Promise.all([
        api.getRankings(metric),
        api.getMyRanking(),
      ]);
      setRankings(rRes.data.rankings || []);
      setTotal(rRes.data.total || 0);
      setMyRanking(mRes.data.ranking);
    } catch (err) { console.error(err); }
  }, [metric]);

  useEffect(() => { load(); }, [load]);

  const metrics = [
    { key: 'total_wealth', label: 'WEALTH', icon: '₢' },
    { key: 'fleet_power', label: 'FLEET', icon: '▲' },
    { key: 'market_profit', label: 'PROFIT', icon: '◈' },
    { key: 'missions_completed', label: 'MISSIONS', icon: '◎' },
  ];

  const getRankClass = (rank) => {
    if (rank === 1) return 'rank-gold';
    if (rank === 2) return 'rank-silver';
    if (rank === 3) return 'rank-bronze';
    return '';
  };

  const renderRankChange = (change) => {
    if (change == null) return null;
    if (change > 0) return <span className="rank-change rank-up" title={`Up ${change}`}>▲{change}</span>;
    if (change < 0) return <span className="rank-change rank-down" title={`Down ${Math.abs(change)}`}>▼{Math.abs(change)}</span>;
    return <span className="rank-change rank-same" title="Unchanged">—</span>;
  };

  return (
    <div className="panel leaderboard-panel">

      {/* My stats */}
      {myRanking && (
        <section className="section">
          <h3 className="section-title"><span className="title-accent">★</span> YOUR POSITION</h3>
          <div className="hud-grid my-stats-grid">
            {metrics.map(m => {
              const data = myRanking[m.key];
              return (
                <div key={m.key} className="hud-card stat-card">
                  <div className="stat-icon">{m.icon}</div>
                  <div className="stat-label">{m.label}</div>
                  <div className="stat-rank">#{data?.rank || '—'}</div>
                  <div className="stat-value">{Number(data?.value || 0).toLocaleString()}</div>
                </div>
              );
            })}
          </div>
        </section>
      )}

      {/* Metric filter */}
      <section className="section">
        <div className="section-header">
          <h3 className="section-title"><span className="title-accent">★</span> GALACTIC RANKINGS</h3>
          <div className="metric-tabs">
            {metrics.map(m => (
              <button
                key={m.key}
                className={`tab-btn tab-sm ${metric === m.key ? 'active' : ''}`}
                onClick={() => setMetric(m.key)}
              >
                {m.icon} {m.label}
              </button>
            ))}
          </div>
        </div>

        {/* Rankings Table */}
        <div className="hud-table-wrap">
          <table className="hud-table leaderboard-table">
            <thead>
              <tr>
                <th>RANK</th>
                <th>COMMANDER</th>
                <th>TYPE</th>
                <th>{metrics.find(m => m.key === metric)?.label}</th>
              </tr>
            </thead>
            <tbody>
              {rankings.map(r => (
                <tr key={`${r.user_type}-${r.user_id || r.rank}`} className={`${r.user_type === 'ghost' ? 'ghost-row' : ''} ${getRankClass(r.rank)}`}>
                  <td>
                    <span className={`rank-num ${getRankClass(r.rank)}`}>
                      {r.rank <= 3 ? ['🥇', '🥈', '🥉'][r.rank - 1] : `#${r.rank}`}
                    </span>
                    {renderRankChange(r.rankChange)}
                  </td>
                  <td className="commander-cell">
                    <span className="commander-name">{r.name}</span>
                  </td>
                  <td>
                    <span className={`type-badge ${r.user_type}`}>
                      {r.user_type === 'ghost' ? '🤖 AI' : '👤 PLAYER'}
                    </span>
                  </td>
                  <td className="value-cell">{Number(r[metric] || 0).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {total > rankings.length && (
          <p className="hud-empty">Showing top {rankings.length} of {total} commanders</p>
        )}
      </section>
    </div>
  );
}

export default LeaderboardPanel;
